import React, { useMemo, useState } from "react"
import { useViewport } from 'components/general/useViewPort'
import MirsTable from "components/general/table/Table"
import {
    ColumnCompetitor,
    ColumnDateTimeNOC,
    ColumnDiscipline,
    ColumnEvent,
    ColumnEventWithCompetitor,
    ColumnLocationNOC,
    ColumnResult,
    ColumnSport,
    ColumnStartTime,
    ColumnStatus
} from "components/common/schedule/TableColumns"
import { useNavigateTo, useUrlFriendlyToParameters, useGetURL } from 'helpers/urlFriendly';
import { getLevelRSC, getEventRSC, getRscObject } from "helpers/rsc";

const getConfiguration = (breakPoint, paramsURL, getURL) => {
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    let configuration = {
        columns: [],
        sortBy: [],
        disableSort: false
    };
    configuration.sortBy = [{ id: 'Time', desc: false }]
    configuration.columns = isMobile ? TableColumnsSM(paramsURL, getURL) : TableColumns(configuration.disableSort, paramsURL, getURL)

    return configuration;
};


const NocScheduleTable = ({ data }) => {
    const { breakPoint } = useViewport();
    const { mirs_noc } = useUrlFriendlyToParameters()
    const params = useUrlFriendlyToParameters()
    let paramsURL = { ...params }
    const getURL = useGetURL()
    const config = useMemo(() => getConfiguration(breakPoint, paramsURL, getURL), [breakPoint]);
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, 'results')

    //Prepare URL to navigate
    const handleClick = (props) => {
        const resultRSC = (props?.eventUnit?.resultRSC)
        const rsc = resultRSC || props?.eventUnit?.code;
        const objRsc = getRscObject(rsc)
        paramsURL["mirs_event"] = getEventRSC(rsc)
        paramsURL["mirs_rsc"] = rsc
        paramsURL["mirs_discipline"] = objRsc.discipline
        setParamsUrl(paramsURL);
        if (rsc.indexOf('TRNO') === -1 && rsc.indexOf('TMRY') === -1 && (props.status?.code !== "CANCELLED") && (props?.eventUnit?.type !== "NONE")) {
            setShouldNavigate(true);
        }
    };
    return (

        <MirsTable
            className="table-schedule"
            data={data}
            columns={config.columns}
            // hiddenColumns={['Location','Result']}
            keyRow='eventUnit-code'
            initialSortBy={config.sortBy}
            rowOnClick={true}
            rowClickHandler={handleClick}
            id={`mirs-table-schedule-${mirs_noc}`}
        />
    )
}

export default NocScheduleTable;


function TableColumns(disableSort, paramsURL, getURL) {
    return (
        [
            ColumnSport({ disableSort: true }),
            ColumnStartTime({ disableSort: true }),
            ColumnLocationNOC({ disableSort: true }),
            ColumnEvent({ disableSort: true, paramsURL, getURL }),
            ColumnCompetitor({ paramsURL }),
            ColumnResult({}),
            ColumnStatus({})
        ]
    )
}

function TableColumnsSM(paramsURL, getURL) {
    return (
        [
            ColumnDiscipline({}),
            ColumnDateTimeNOC({ disableSort: true }),
            ColumnEventWithCompetitor({ disableSort: true, paramsURL, getURL }),
            ColumnStatus({})
        ]
    )
}


